import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
      <p class="mb-3">
        Как давно это было…
      </p>
      
      <p class="mb-3">
        Так давно, что даже прадеды не помнят.
      </p>
      
      <p class="mb-5">
        Только рапсоды поют об этом в своих бесконечных пёстрых длинновьющихся сказах.
      </p>
      
      <p class="mb-3">
        Когда-то был Рай на Земле; сейчас его нет, и даже места не сыщешь… 
        Когда-то был Рай на Земле, с текущими реками, зелёными садами, и лепестки роз шептались с ветром. 
        Когда-то сверкающие росы покрывали травы, и эти росы были мёдом, и люди питались им. 
        Чистую сладкую воду они пили, одевались в паутину и весь день проводили среди цветов, на зелёном лугу. 
        Солнце ласково сияло им, согревая своими лучами…
      </p>
      
      <p class="mb-5">
        Как давно это было.
      </p>
      
      <p class="mb-5">
        Сейчас, когда грозно мечет Солнце свои стрелы в людей; когда сохнут и вянут молодые ростки; когда грозы бросают на землю пламя, 
        и это пламя пожирает всё вокруг – о, сейчас те, кто успел спастись, тем более просят рассказов о прошлом. 
        Никто в эти рассказы не верит, их даже не воспринимают всерьёз – но всё же, время от времени мы хотим слушать о нашем прошлом, 
        хотим воспоминаний.
      </p>
      
      <p class="mb-5">
        Когда-то. В Раю…
      </p>
      
      <p class="mb-5">
        Сейчас никто не думает о той женщине, которая сорвала Плод с дерева. 
        Ведь мы все – её потомки. 
        Её грех уже давно позабыт…
      </p>
      
      <p class="mb-3">
        Но никогда не забудут её те, с чьего дерева она сорвала плод. 
        С бессильными проклятьями они вспоминают Ту, которая повредила их корабль, оставив их навсегда на чуждой и ненавистной планете.
      </p>
      
      <p class="mb-3">
        Только двух животных они спасли тогда от страшного пожара, уничтожившего всё живое на Земле. 
      </p>
      
      <p class="mb-3">
        Правда, причиной пожара было их собственное прибытие – да разве это важно? 
        Такие планетки с примитивной жизнью на каждом шагу встречаются в Космосе. 
        И несмотря на это, они, с благими намерениями, приютили на корабле двух аборигенов, чтобы выпустить их обратно, когда кончится пожар. 
      </p>
      
      <p class="mb-3">
        И эти безмозглые скоты сделали именно то, что им было строго запрещено: 
        они приблизились к нашему главному Двигателю и полностью разрушили его!
      </p>
      
      <p class="mb-5">
        О, не одно яблочко они взяли, как сладко-идиллически рассказывали потом своим внукам! 
        Они всё дерево изломали – яростно, дико, будто пытаясь отомстить своим благодетелям за их лёгкую, беззаботную жизнь.
      </p>
      
      <p class="mb-3">
        Мы остались.
      </p>
      
      <p class="mb-3">
        Без помощи давно уже сгнившего корабля, мы смешались с потомками этих двоих. 
        Сначала нас было гораздо больше, но из-за плохих условий многие из нас погибли, и вскоре потомков людей на Земле стало больше, чем нас. 
      </p>
      
      <p class="mb-3">
        Сейчас мы живём среди них, слушаем их сказания, и лишь неправду мы слышим, лишь обман. 
      </p>
      
      <p class="mb-5">
        Внешне мы выглядим точно как они, но мы всегда чувствуем друг друга; и они своим животным чутьём чувствуют наших; 
        и двум этим племенам не соединиться, не понять и не принять другого.
      </p>
      
      <p class="mb-3">
        У нас была общая мыслительная сеть: когда одному из нас было плохо или одиноко, мы соединялись и помогали друг другу. 
      </p>
      
      <p class="mb-5">
        Но столько столетий прошло… 
        Мы терялись среди миллионов чужих…
      </p>
      
      <p class="mb-3">
        Сейчас уже давно я один. 
        На мои призывы никто не откликается. 
        Может, все близкие мне уже исчезли, растворились в этом множестве животных, в бесконечно растущей массе? 
        Я каждый день смотрю на их лица: нет, они мне чужие. 
        В их глазах – ничего, кроме зависти и злобы. 
        Наверное, я остался один… 
        Я слушаю их рапсодов, и вспоминаю Рай, наш прекрасный Рай, где так плавно лились чистые воды и жёлтое солнце согревало росу на листьях. 
      </p>
      
      <p class="mb-5">
        Я вспоминаю о многих из нас – умных, красивых, гордых. 
        Я верю в наш дух, который спасёт нас от Земли, и мы продолжим наш путь – в дух Науки, Разума, Интеллекта. 
        Он ведь не может исчезнуть, он спасёт нас!
      </p>
      
      <p class="mb-3">
        Как давно это было…
      </p>
    </div>
    `
  )
}

const itemName = {
  rus: `Одинокий`
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;




